import { assets } from '../assets/assets';


const NewsCollection = () => {
  return (
    <div>
      {/* <!-- ======================= news portal start  ============================ --> */}
      <div className="news_portal py-4">
        <div className="container-fluid">
          <div className="heading text-center mb-5">
            <h2 className="title">Celebs Mention & News</h2>
          </div>

          <marquee behavior="" direction="" loop pauseOnHover={false}>

            <img src={assets.brand_img1} alt="brand1" className="marquee-img" />

            <img src={assets.brand_img2} alt="brand2" className="marquee-img" />


            <img src={assets.brand_img3} alt="brand3" className="marquee-img" />

            <img src={assets.brand_img4} alt="brand4" className="marquee-img" />
            <img src={assets.brand_img5} alt="brand5" className="marquee-img" />
            <img src={assets.brand_img1} alt="brand1" className="marquee-img" />

            <img src={assets.brand_img2} alt="brand2" className="marquee-img" />


            <img src={assets.brand_img3} alt="brand3" className="marquee-img" />

            <img src={assets.brand_img4} alt="brand4" className="marquee-img" />
            <img src={assets.brand_img5} alt="brand5" className="marquee-img" />
            <img src={assets.brand_img1} alt="brand1" className="marquee-img" />

            <img src={assets.brand_img2} alt="brand2" className="marquee-img" />


            <img src={assets.brand_img3} alt="brand3" className="marquee-img" />

            <img src={assets.brand_img4} alt="brand4" className="marquee-img" />
            <img src={assets.brand_img5} alt="brand5" className="marquee-img" />


          </marquee>

        </div>
      </div>
      {/* <!-- ======================= news portal end  ============================ --> */}
    </div>
  );
};

export default NewsCollection;
